import type { UnionTypeLibelle } from '../../../techniques'

export const ModalitePedagogique = ['Presentielle', 'Mixte', 'Distance', 'Afest', 'Foad'] as const
export type ModalitePedagogique = (typeof ModalitePedagogique)[number]

export const ModalitePedagogiqueLibelle: UnionTypeLibelle<ModalitePedagogique> = {
  Presentielle: 'Présentielle',
  Mixte: 'Mixte',
  Distance: 'A distance (présence d’un formateur)',
  Afest: 'AFEST',
  Foad: 'FOAD (e-learning sans formateur)',
} as const
